// 会场管理 actions - 可扩展登录请求等异步操作
export default {
  // 预留登录 action 示例
  // login({ commit }, params) { ... }
}
